<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>寄存信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">寄存单号</div>
              <div class="itemNum">{{ form.id }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">下单顾客</div>
              <div class="itemNum">{{ form.customerName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">手机号码</div>
              <div class="itemNum">{{ form.mobile }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">寄存门店</div>
              <div class="itemNum">{{ form.shopName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">寄存技师</div>
              <div class="itemNum">{{ form.staffNames }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">单据状态</div>
              <div class="itemNum">{{ form.depositTypeCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">寄存时间</div>
              <div class="itemNum">{{ this.form.oxCtime }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">备注</div>
              <div class="itemNum">{{ form.remark }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>寄存明细</i></p>
          <div class="totals-box mlr24 ">
            <el-row class="deposit-details">
              <el-col :span="10" class="pl10">商品名称</el-col>
              <el-col :span="4">单价(元)</el-col>
              <el-col :span="3">数量</el-col>
              <el-col :span="7" class="tRight pr10">过期时间</el-col>
            </el-row>
            <el-row v-for="(item,index) in form.itemList" :key="index" class="mt20">
              <el-col :span="10" class="pl10">{{item.itemName}}</el-col>
              <el-col :span="4" class="color999">{{item.salePrice}}</el-col>
              <el-col :span="3" class="color999">{{item.itemNum}}</el-col>
              <el-col :span="7" class="tRight pr10 color999">{{formatDay(item.expireTime)}}</el-col>
            </el-row>
          </div>
          <p class="order-title-boxs" v-if="deductInfo.length != 0"><span class="blueBlock"></span><i>领取明细</i></p>
          <div class="totals-box customTable" v-if="deductInfo.length != 0">
            <div class="detail plr20">
              <!-- <el-table :data="deductInfo" input-large header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="staffNames" label="寄存技师" width="80"></el-table-column>
                <el-table-column label="商品信息" width="auto">
                  <template slot-scope="scope">{{scope.row.itemNames}}*{{scope.row.itemNum}}{{scope.row.unit}}</template>
                </el-table-column>
                <el-table-column prop="remark" label="备注信息" width="auto"></el-table-column>
                <el-table-column prop="useStyle" label="领取状态" width="80">
                  <template slot-scope="scope">
                    <p v-if="scope.row.useStyle == 'receive'">领取</p>
                    <p v-if="scope.row.useStyle == 'use'">使用</p>
                  </template>
                </el-table-column>
                <el-table-column prop="drawTypeCn" label="领取类型" width="auto"></el-table-column>
                <el-table-column label="时间" width="160" align="right">
                  <template slot-scope="scope">{{ formatDate(scope.row.oxCtime)}}</template>
                </el-table-column>
              </el-table> -->

              <el-table
                :data="deductInfo"
                style="width: 100%">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <!-- v-if="props.row.useStyle='receive'" -->
                    <el-form v-for="(item,index) in props.row.itemList" :key="index" label-position="left" inline class="demo-table-expand">
                      <el-form-item label="领取产品">
                        <span>{{item.itemName}}*{{item.itemNum}}{{item.unit}}</span>
                      </el-form-item>
                      <el-form-item label="领取类型">
                        <span>{{ item.drawTypeCn }}</span>
                      </el-form-item>
                      <el-form-item label="顾客签名">
                        <div class="down-img" v-if="props.row.signUrl"><img :src="props.row.signUrl"></div>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column label="商品信息" prop="itemNames" width="auto"></el-table-column>
                <el-table-column label="寄存技师" prop="staffNames" width="auto"></el-table-column>
                <el-table-column label="备注信息" prop="remark"> </el-table-column>
                <el-table-column prop="useStyle" label="领取状态" width="80">
                  <template slot-scope="scope">
                    <p v-if="scope.row.useStyle == 'receive'">领取</p>
                    <p v-if="scope.row.useStyle == 'use'">使用</p>
                  </template>
                </el-table-column>
                <el-table-column label="时间" width="160" align="right">
                  <template slot-scope="scope">{{ formatDate(scope.row.oxCtime)}}</template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        
        <div class="drawer-footer pr24 pb10">
            <!-- 领取标识status notGet  -->
            <el-button v-if="form.status == 'notGet'" class="ml10" @click="receiveProduct">领取</el-button>
        </div>
      </div>
    </drawer>
    <receiveProduct-set ref="receiveProductSetForm" @receiveProductChange="receiveProductChange"></receiveProduct-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import payDialog from "../../components/pay-dialog";
import receiveProductSet from "./receiveProduct.vue";

import Dialog from "../../../components/common/dialog.vue";
export default {
  mixins: [minxin],
  components: {
    drawer,
    payDialog,
    Dialog,
    receiveProductSet,
  },
  props: {
      typeCate: {
          type: String,
          default: 'reserve'
      }
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "寄存详情",
      dialogHide: false,
      depositId: "",
      form: {
        orderType: ""
      },
      dialogHide: false,
      //领取明细
      deductInfo: []
    };
  },
  created() {
    
    this.init();
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("payMobile"))) {
      let arr = JSON.parse(localStorage.getItem("payMobile"));
      if (arr.path == this.$route.path) {
        this.$refs["paySuccessForm"].$emit("set", arr);
      }
    }
    window.addEventListener('beforeunload', this.beforeunloadHandler, false)
  },
  destroy() {
    window.removeEventListener('beforeunload', this.beforeunloadHandler, false)
  },
  methods: {
    beforeunloadHandler(e) {
      // 监听网页刷新事件
      localStorage.removeItem("payMobile")
    },

    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
          this.depositId = org;
          this.getDuctList(org)
          this.$api.get(this.$url.report.productDepositDetail, {
            id: org
          }).then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
              this.form.id = String(this.form.id)
              this.form.oxCtime = this.formatDate(this.form.oxCtime);
            }
          }).catch(error => {});
      });
    },
    getDuctList (org) {
      console.log(org);
        this.$api.post(this.$url.report.productDepositTakeInfoList, {depositId: org}).then(ret => {
            if (ret) {
                console.log(this.depositId, '领取明细   ');
                this.deductInfo = ret;
            }
        });
    },
    receiveProduct() {
      //领取
      this.$refs["receiveProductSetForm"].$emit("set", {id:this.form.id,customerName:this.form.customerName});
    },
    receiveProductChange() {

      console.log(this.depositId, '6666   ');

      this.getDuctList(this.depositId)
      this.$api.get(this.$url.report.productDepositDetail, {
        id: this.depositId
      }).then(res => {
        if (res) {
          this.form = res;
          this.form.id = String(this.form.id);
          this.form.oxCtime = this.formatDate(this.form.oxCtime);

          this.$emit("change", true);
        }
      }).catch(error => {});
    },
    handleChange(bool) {
      if (bool) {
        this.addEditShow = false;
      }
    },
    back () {
      localStorage.removeItem("payMobile")
      this.addEditShow = false;
    },
  }
};
</script>

<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  .titles-head {
    border-top: 0;
  }
  .deposit-details {
    height: 56px;
    line-height: 56px;
    background: #F7F8FA;
  }
}
.dialog-staff-box {
  .body-content {
    .deduct-amount {
      display: flex;
      justify-content: space-between;
      margin: 0 30px;
      font-size: 16px;

      
    }
    .body-title {
      text-align: right;
      color: #2795fd;
      cursor: pointer;
      i {
        margin-right: 9px;
      }
    }
    .boxs {
      margin: 0 29px;
      font-size: 16px;
      .box {
        margin-top: 20px;
        background-color: #f3f3f3;
        border-radius: 4px;
        color: #282828;
        display: flex;
        align-items: center;
        .flex {
          flex: 1;
          margin-right: 42px;
          .staffs-msg {
            padding-top: 20px;
            display: flex;
            justify-content: space-between;
            // align-items: center;
            .img {
              cursor: pointer;
            }
            .staff-name {
              display: flex;
              align-items: center;
            }
            .add-img {
              width: 35px;
              vertical-align: middle;
              position: relative;
              &::before {
                content: "+";
                position: absolute;
                font-size: 24px;
                height: 35px;
                top: 0;
                left: 0;
                width: 35px;
                text-align: center;
              }
            }
            .notStaff {
              position: relative;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              width: 133px;
              height: 33px;
              cursor: pointer;
              display: flex;
              justify-content: center;
              .span {
                left: 45px;
                position: absolute;
                height: 33px;
                display: flex;
                align-items: center;
                &::before {
                  content: "+";
                  font-size: 24px;
                  position: absolute;
                  left: -20px;
                  color: #333;
                  height: 35px;
                  top: 0;
                }
              }
            }
          }
          .deduct-msg {
            padding: 20px 0;
            display: flex;
            justify-content: space-between;
          }
          .label {
            margin-left: 26px;
          }
        }
        .close {
          margin-right: 20px;
          font-size: 25px;
          cursor: pointer;
        }
      }
    }
  }
}

.down-img {

width: 40px;
height: 40px;
}
.down-img img {
width: 100%;
height: 100%;
}

.demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }

</style>